import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
    public authKey: string;
    
    constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts